// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9n-4";
export var collapsed = "_9n-1";
export var headerBar = "_9n-0";
export var leftHeaderContent = "_9n-3";
export var subjectContainer = "_9n-2";